import React, { useState, useEffect } from "react";
import PensionForm1 from "./pensionForm1";
import PensionFormMar from "./pensionForm1Marathi";
import PensionForm2 from "./pensionForm2";
import PensionForm3 from "./pensionForm3";
import PensionForm4 from "./pensionForm4";
import PensionForm5 from "./pensionForm5";
import PensionForm6 from "./pensionForm6";

import { useFormSubmission } from "../../pages/payment/customPayment";

import {
  handleFormDataChange,
  handleNextStep,
  handlePreviousStep,
  
} from "../../components/formHandlers"; 
import "../../../style/google_forms.css"; 





const pensionHighSchool = () => {

  const initialFormState = {
    //Form 1
    employeeName: '',
    fatherName: '',
    email: '',
    phoneNumber: '',
    address: '',
    gender: '',
    nationality: '',
    religion: '',
    designation: '',
    Height: '',
    splMark: '',
    dateOfBirth: '',
    adharno: '',
    panno: '',
    employeecode: '',
    pfno: '',
    dateOfAppointment: '',
    dateOfService: '',
    dateOfRetirement: '',
    typeOfRetirement: '',
    classOfPost: '',
    placeOfRetirement: '',

    //Marathi Input
    employeeNameMar: '',
    institutionNameMar: '',
    designationMar: '',
    regionMar: '',
    regionalPlaceMar: '',

    //Form 2
    spouseName: '',
    spouseDOB: '',
    spouceRelation: '',
    childDetails: [],

    //Form 3
    bankName: '',
    branchName: '',
    accountNumber: '',
    ifscCode: '',
    
    //Form 4
    institutionName: '',
    establishmentDate: '',
    aidedDate: '',
    managementName: '',
    region: '',
    city: '',
    treasury: '',
    educationOfficer: '',
    ddoCode: '',
    ddoretired: '',
    todcrg: '',

    //Form 5
    nonQualifyServiceYears: '',
    nonQualifyServiceMonths: '',
    nonQualifyServiceDays: '',
    qualifyServiceYears: '',

    //Form 6
    payLevel: '',
    payrateTable: [],
    basicPay: '',
    notionalPay: '',
    DA: '',
    HRA: '',
    TRA: '',
    CLA: '',
    splPay: '',
  };
  const dummyFormData = {
    // Form 1
    employeeName: 'Madhuri Dixit',
    fatherName: 'Rajesh Khanna',
    email: 'rajesh.kumar@example.com',
    phoneNumber: '9876543210',
    address: '159 Guruwar Peth, Satara',
    gender: 'Male',
    nationality: 'Indian',
    religion: 'Hindu',
    designation: 'Clerk',
    Height: '5ft 9in',
    splMark: 'Mole on right hand',
    dateOfBirth: '1965-08-15',
    adharno: '123456789012',
    panno: 'ABCDE1234F',
    employeecode: 'EMP456789',
    pfno: 'PF123456',
    dateOfAppointment: '1989-06-01',
    dateOfService: '1990-01-01',
    dateOfRetirement: '2025-03-31',
    typeOfRetirement: 'Superannuation Retirement',
    classOfPost: 'III',
    placeOfRetirement: 'Satara',
  
    //MarathiInp
  employeeNameMar: 'सुभाष माने',
  institutionNameMar: 'शासकीय तंत्रनिकेतन, पुणे',
  designationMar: 'वरिष्ठ लिपिक',
  regionMar: 'पश्चिम महाराष्ट्र',
  regionalPlaceMar: 'पुणे',

    // Form 2
    spouseName: 'Sangeeta Kumari',
    spouseDOB: '1968-10-20',
    spouceRelation: 'Wife',
    childDetails: [
      { nameChild: 'Amit Kumar', dobChild: '1995-05-12', relationship: 'Son' },
      { nameChild: 'Neha Kumari', dobChild: '1998-09-23', relationship: 'Daughter' }
    ],
  
    // Form 3
    bankName: 'State Bank of India',
    branchName: 'Satara Main Branch',
    accountNumber: '123456789012',
    ifscCode: 'SBIN0000123',
  
    // Form 4
    institutionName: 'New English School',
    establishmentDate: '1990-01-01',
    aidedDate: '1995-01-01',
    managementName: 'Satara Education Society',
    region: 'Kolhapur Region',
    city: 'Kolhapur',
    treasury: 'Satara Treasury Office',
    educationOfficer: 'Mr. A.B. Pawar',
    ddoCode: 'DDO1234',
    ddoretired: '2025-03-31',
    todcrg: '100000',
  
    // Form 5
    nonQualifyServiceYears: '2',
    nonQualifyServiceMonths: '4',
    nonQualifyServiceDays: '15',
    qualifyServiceYears: '33',
  
    // Form 6
    payLevel: 'S-1',
    payrateTable: [
      { from: "2019-06-1", to: "2020-02-29", payrate: 1500 },
    { from: "2020-03-01", to: "2020-03-31", payrate: 1800 }
    ],
    basicPay: '44900',
    DA: '7633',
    HRA: '5388',
    TRA: '1800',
    CLA: '200',
    splPay: '0',
  };
  
 const [formData, setFormData] = useState(initialFormState);
   const { handleFormSubmission, isSubmitting, PaymentWindowComponent  } = useFormSubmission();
 
  
  const [step, setStep] = useState(1);

  const handleNext = () => {
    handleNextStep(setStep);
  };

  const handleBack = () => {
    handlePreviousStep(setStep);
  };


  const formConfig = {
    apiEndpoint: `${process.env.REACT_APP_BACKEND_URL}/api/pensionHighSchool/submit-pension`,
    paymentDescription: "Payment for Pension Case Documents",
    successRoute: "/pensionHighSchool/pensionCase-result",
    name: formData.employeeName,
    formType: "Pension Case High School",
    email: formData.email,
    contact: formData.phoneNumber,
  };

const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.employeeName || !formData.email || !formData.phoneNumber) {
      Swal.fire({
        icon: 'error',
        title: 'Missing Required Fields',
        text: 'Please fill all required fields before submitting.'
      });
      return;
    }     
      // Submit after state update
      handleFormSubmission(formData, formConfig);
  };
  


  useEffect(() => {
    try {
      const savedFormData = JSON.parse(localStorage.getItem("formData"));
      if (savedFormData) {
        setFormData((prev) => ({ ...prev, ...savedFormData }));
      }
    } catch (err) {
      console.error("Failed to parse formData from localStorage", err);
    }
  }, []);
  
  

  return (
    <div>
      {step === 1 && (
        <PensionForm1
          formData={formData}
          setFormData={setFormData}
          onNext={handleNext}
          onFormDataChange={(data) => handleFormDataChange(formData, setFormData, data)}
        />
      )}
        {step === 2 && (
        <PensionFormMar
          formData={formData}
          setFormData={setFormData}
          onBack={handleBack}
          onNext={handleNext}
          onFormDataChange={(data) => handleFormDataChange(formData, setFormData, data)}
        />
      )}
    {step === 3 && (
        <PensionForm2
          formData={formData}
          setFormData={setFormData}
          onBack={handleBack}
          onNext={handleNext}
          onFormDataChange={(data) => handleFormDataChange(formData, setFormData, data)}
        />
      )}

    {step === 4 && (
        <PensionForm3
          formData={formData}
          setFormData={setFormData}
          onBack={handleBack}
          onNext={handleNext}
          onFormDataChange={(data) => handleFormDataChange(formData, setFormData, data)}
        />
      )}

    {step === 5 && (
        <PensionForm4
          formData={formData}
          setFormData={setFormData}
          onBack={handleBack}
          onNext={handleNext}
          onFormDataChange={(data) => handleFormDataChange(formData, setFormData, data)}
        />
      )}

    {step === 6 && (
        <PensionForm5
          formData={formData}
          setFormData={setFormData}
          onBack={handleBack}
          onNext={handleNext}
          onFormDataChange={(data) => handleFormDataChange(formData, setFormData, data)}
        />
      )}

    {step === 7 && (
        <PensionForm6
          formData={formData}
          setFormData={setFormData}
          onBack={handleBack}
          onFormDataChange={(data) => handleFormDataChange(formData, setFormData, data)}
          onSubmit={handleSubmit}
        />
      )}
    {PaymentWindowComponent}

    </div>
  );
};

export default pensionHighSchool;
